//
//
//
//
//
//
//
//
//
//
//

import error from "../layouts/error.vue";
import { Result } from "ant-design-vue";
import "ant-design-vue/es/result/style/index.css"

export default {
  props: ['error'],
  layout: 'default',
  components: {
    'a-result': Result
  },
  computed: {
    subTitle() {
      const defaultMessages = {
        404: 'Запрашиваемая страница не найдена',
        403: 'Недостаточно прав для открытия этого ресурса',
      }

      return this.error?.humanReadableMessage ?? defaultMessages[this.error.statusCode]
    }
  }
}
